import {
  GET_ADDITIONAL_CUSTOMER,
  GET_ADDITIONAL_CUSTOMER_FAILED,
  GET_ADDITIONAL_CUSTOMER_SUCCESS,
  GET_CUSTOMER,
  GET_CUSTOMER_FAILED,
  GET_CUSTOMER_REQUIRED_DETAILS,
  GET_CUSTOMER_REQUIRED_DETAILS_FAILED,
  GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS,
  GET_CUSTOMER_SUCCESS,
  UPDATE_ADDITIONAL_CUSTOMER,
  UPDATE_ADDITIONAL_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_BOOKING_DELIVERIES,
  UPDATE_CUSTOMER_BOOKING_DELIVERIES_SUCCESS,
  UPDATE_CUSTOMER_SUCCESS,
} from './types';

export const getCustomer = {
  type: GET_CUSTOMER,
};

export const getCustomerSuccess = customer => ({
  type: GET_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const getCustomerFailed = error => ({
  type: GET_CUSTOMER_FAILED,
  payload: { error },
});

export const getCustomerRequiredDetails = () => ({
  type: GET_CUSTOMER_REQUIRED_DETAILS,
});

export const getCustomerRequiredDetailsSuccess = requiredDetails => ({
  type: GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS,
  payload: { requiredDetails },
});

export const getCustomerRequiredDetailsFailed = error => ({
  type: GET_CUSTOMER_REQUIRED_DETAILS_FAILED,
  payload: { error },
});

export const updateCustomer = (fields, redirectPath) => ({
  type: UPDATE_CUSTOMER,
  payload: { fields, redirectPath },
});

export const updateCustomerDeliveries = (
  bookingRefs,
  fields,
  redirectPath,
) => ({
  type: UPDATE_CUSTOMER_BOOKING_DELIVERIES,
  payload: { bookingRefs, fields, redirectPath },
});

export const updateCustomerSuccess = () => ({
  type: UPDATE_CUSTOMER_SUCCESS,
});

export const updateCustomerDeliveriesSuccess = () => ({
  type: UPDATE_CUSTOMER_BOOKING_DELIVERIES_SUCCESS,
});

export const getAdditionalCustomer = customerId => ({
  type: GET_ADDITIONAL_CUSTOMER,
  payload: { customerId },
});

export const getAdditionalCustomerSuccess = customer => ({
  type: GET_ADDITIONAL_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const getAdditionalCustomerFailed = customerId => ({
  type: GET_ADDITIONAL_CUSTOMER_FAILED,
  payload: { customerId },
});

export const updateAdditionalCustomer = (
  customerId,
  bookingRef,
  fields,
  redirectPath,
) => ({
  type: UPDATE_ADDITIONAL_CUSTOMER,
  payload: { customerId, bookingRef, fields, redirectPath },
});

export const updateAdditionalCustomerSuccess = () => ({
  type: UPDATE_ADDITIONAL_CUSTOMER_SUCCESS,
});
